import _ from "underscore";
import { pathname } from "../others/Configuration";
import translation from "../others/translation";
import $ from "jquery";
import Backbone from "backbone";
import { CONFLICT } from "../../api/HTTPStatus";

export const checkedClassName = 'checked';

export default Backbone.View.extend({
  reviews: [],
  initialize: function (opts) {
    this.prid = opts.prid;
    this.$form = this.$('#formNewReview');
    this.$criteriasSection = this.$form.find('.js-CriteriasSection');
    this.initializeValidation();
    this.isFetching = false;
  },

  initializeValidation: function () {
    $.validator.unobtrusive.parse(this.$form);
    var settings = $.data(this.$form[0], 'validator').settings;
    settings.ignore = '';
  },

  events: {
    'submit #formNewReview': 'submitForm',
    'change .js-ReviewRating-input': 'reviewValueChanged',
    'mouseover .js-Stars': 'onHoverStars',
    'mouseleave .js-ReviewRating': 'onMouseLeaverStars',
    'change .js-StrongPoints': 'strongPointsChanged',
    'click .popinReview-readMore': 'showFullMentions'
  },

  showFullMentions: function (e) {
    e.preventDefault();
    this.$('.popinReview-mentions-content').toggleClass('visible');
  },

  strongPointsChanged: function (e) {
    this.forceWeaknessIsValid();
  },

  reviewValueChanged: function (e) {
    var $this = $(e.currentTarget);
    this.ratingCriteriaToRender = {
      $item: $this,
      value: Number($this.val())
    };
    this.render();
  },

  submitForm: function (e) {
    e.preventDefault();

    if (this.isFetching) {
      return;
    }

    var formIsValid = this.$form.valid();
    var criteriasIsValid = this.criteriasIsValid();
    var forceWeaknessIsValid = this.forceWeaknessIsValid();

    if (formIsValid && criteriasIsValid && forceWeaknessIsValid) {
      var newReview = this.getReviewToCreate();
      var url = [pathname, '/nav/api/products/', this.prid, '/reviews'].join('');
      this.$(".popinReviewsubmit").addClass("f-button--loading");

      var request = $.ajax({
        type: 'POST',
        url: url,
        data: JSON.stringify(newReview),
        contentType: 'application/json'
      });

      const $newReview = $(".js-productReviewButton").length ? $(".js-productReviewButton") : $(".js-NewReview");

      request
        .done(() => {
          const successText = translation("front.core.views.product.review.sucessreviewmessage");
          $newReview.attr("disabled", true);
          $newReview.addClass("ff-button--forestGreen").removeClass("ff-button--orange");
          $newReview.html(successText);
          $.magnificPopup.close();
        })
        .fail((jqXHR, textStatus, errorMsg) => {
          if (jqXHR.status === CONFLICT) {
            const errorText = translation("front.core.views.product.review.conflit.error");
            $newReview.attr("disabled", true);
            $newReview.addClass("ff-button--black").removeClass("ff-button--orange");
            $newReview.html(errorText);
          }
          $.magnificPopup.close();
        });

      this.isFetching = true;
    }
  },

  forceWeaknessIsValid: function () {
    var $section = this.$form.find('.js-ForceWeaknessSection');
    var $inputs = $section.find('input');

    var oneItemIsDefined = _.some($inputs, function (item) {
      return item.value !== '';
    });

    var allItemsAreDefined = _.every($inputs, function (item) {
      return item.value !== '';
    });

    var isValid = !oneItemIsDefined || allItemsAreDefined;
    var $validationMessage = $section.find('.js-ForceWeaknessValidationMessage');

    if (isValid) {
      $validationMessage.text('');
      $validationMessage.addClass('field-validation-valid');
      $validationMessage.removeClass('field-validation-error');
    } else {
      $validationMessage.text(translation("front.core.views.product.review.forceweakness.required.error.message"));
      $validationMessage.removeClass('field-validation-valid');
      $validationMessage.addClass('field-validation-error');
    }

    return isValid;
  },

  criteriasIsValid: function () {
    var $stars = this.$criteriasSection.find('.js-ReviewRating-input:checked');
    var $criterias = this.$criteriasSection.find('.js-Criterias');
    var isValid = $stars.length === 0 || $stars.length === $criterias.length;
    var $validationMessage = this.$form.find('.js-CriteriasValidationMessage');

    if (isValid) {
      $validationMessage.text('');
      $validationMessage.addClass('field-validation-valid');
      $validationMessage.removeClass('field-validation-error');
    } else {
      $validationMessage.text(translation("front.core.views.product.review.forceweakness.required.error.message"));
      $validationMessage.removeClass('field-validation-valid');
      $validationMessage.addClass('field-validation-error');
    }

    return isValid;
  },

  getRatings: function () {
    var $stars = this.$criteriasSection.find('.js-ReviewRating-input:checked');
    var ratingCriterias = [];

    $.each($stars, function (index, item) {
      var $item = $(item);
      ratingCriterias.push({
        $item: $item,
        code: $item.data('code'),
        rating: $item.val()
      });
    });

    return ratingCriterias;
  },

  getReviewToCreate: function () {
    var ratingCriterias = this.getRatings().map(function (item) {
      return { code: item.code, rating: item.rating };
    });

    var $force = this.$form.find('#strongPoints_Label');
    var $weakness = this.$form.find('#disadvantages_Label');

    var data = {
      "AuthorInfos": {
        "Nickname": this.$form.find('#AuthorInfos_Nickname').val()
      },
      "Review": {
        "Text": this.$form.find('#Review_Text').val(),
        "Title": this.$form.find('#Review_Title').val(),
        "Rating": this.$form.find('.js-ReviewRating-input:checked').val(),
        "ProductRatingInfos": {
          "RatingCriteriasContainer": {
            "RatingCriterias": ratingCriterias
          },
          "ExtraCriteriasContainer": {
            "ExtraCriterias": [
              { "code": $force.data('code'), "values": [$force.val()] },
              { "code": $weakness.data('code'), "values": [$weakness.val()] }
            ]
          }
        },
        "Article": {
          "ObjectId": this.$form.find('#Review_Article_ObjectId').val(),
          "ObjectModel": this.$form.find('#Review_Article_ObjectModel').val(),
          "PageUrl": this.$form.find('#Review_Article_PageUrl').val()
        }
      }
    };

    return data;
  },

  onHoverStars: function (e) {
    var $this = $(e.currentTarget);
    var reviewValue = Number($this.find('.js-ReviewRating-input').val());
    var ratingLabelValue = translation(`front.core.views.product.author.comments.apreciation.star${reviewValue}`);
    this.$selectedLabel = $this.parents('.js-ReviewRating').children('.js-ratingValueLabel');
    this.$selectedLabel.text(ratingLabelValue);
  },

  onMouseLeaverStars: function (e) {
    if (this.$selectedLabel && this.$selectedLabel.length) {
      var $selectedItem = $(e.currentTarget).find('.checked');
      var ratingLabelValue = translation(`front.core.views.product.author.comments.apreciation.star${$selectedItem.length ? $selectedItem.find('.js-ReviewRating-input').val() : 1}`);
      this.$selectedLabel.text(ratingLabelValue);
    }

    this.$selectedLabel = null;
  },

  render: function () {
    var $selectedItem = this.ratingCriteriaToRender.$item;

    // Remove all checked classes
    var reviews = $selectedItem.parents('.js-ReviewRating');
    var $reviewSpan = reviews.find('span');
    $reviewSpan.removeClass(checkedClassName);
    $reviewSpan.find('.js-ReviewRating-input').prop('checked', false);

    if (this.ratingCriteriaToRender.value > 0) {
      // Add checked class on selected star
      var $selectedStar = $selectedItem.parents('.js-Stars');
      $selectedStar.addClass(checkedClassName);
      $selectedItem.prop('checked', true);
    }
  }
});
